module.exports = __webpack_public_path__ + "static/media/iconActivityParascolaire.1964adcb.svg";